import type { SwapsTranslations } from "../interfaces/swaps";

export const swapsTranslations: SwapsTranslations = {
  swap_title: "Troca de Moedas",
  page_subtitle: "Converta saldo entre suas próprias carteiras na hora, sem destinatário externo.",

  origin_label: "Moeda de Origem",
  destination_label: "Moeda de Destino",
  select_origin: "Selecione a moeda de origem",
  select_destination: "Selecione a moeda de destino",

  amount_origin_label: "Valor de Origem",
  amount_destination_label: "Valor de Destino",

  quote_breakdown: "Detalhamento da Cotação",
  conversion_rate: "Taxa de Conversão",
  you_send: "Você Envia",
  you_receive: "Você Recebe",
  fees: "Taxa",
  recalculate_quote: "Recalcular cotação",

  quote_valid_for: "Esta taxa é válida por",
  quote_expiring_soon: "A cotação expirará em breve",
  quote_expired_message: "A cotação expirou",

  conversion_fee: "Taxa de conversão",
  converted: "Valor convertido",
  total_debit: "Total debitado",

  confirm_swap: "Confirmar Swap",
  make_another_swap: "Fazer Outro Swap",

  success_title: "Swap Bem-sucedido!",
  success_description: "Sua troca de moedas foi concluída com sucesso",
  previous_balance: "Saldo Anterior",
  current_balance: "Saldo Atual",
  change: "Mudança",

  loading_quote: "Obtendo cotação...",
  loading_wallets: "Carregando carteiras...",
  retry: "Tentar novamente",
  error_origin_required: "Selecione uma moeda de origem",
  error_destination_required: "Selecione uma moeda de destino",
  error_amount_required: "Digite um valor válido",
  error_insufficient_balance: "Saldo insuficiente para cobrir o valor e a taxa",
  error_no_quote: "Nenhuma cotação disponível",
  error_swap_failed: "Erro ao realizar o swap",

  available_balance_label: "Saldo disponível:",
  wallet_not_activated_hint: "(não ativada)",
  wallet_will_be_activated: "Uma carteira nesta moeda será ativada ao confirmar o swap",
  no_wallets_title: "Nenhuma carteira ativa",
  no_wallets_message: "Você não tem carteiras ativas. Ative uma na seção Carteiras para trocar moedas.",
  convert_title: "Converter",
  convert_subtitle: "Entre suas carteiras",
  convert_from: "De",
  convert_to: "Para",
  convert_wallet: "Carteira {{currency}}",
  convert_available: "Disponível {{amount}}",
  convert_balance: "Saldo {{amount}}",
  convert_flip: "Inverter carteiras",
  convert_frozen: "Congelada",
  convert_send_label: "Você converte",
  convert_receive_label: "Você recebe",
  convert_rate: "Taxa de câmbio",
  convert_valid_for: "Preço válido por {{time}}",
  convert_row_fee: "Taxa",
  convert_row_debit: "Sai da sua carteira",
  convert_row_credit: "Chega na sua carteira",
  convert_fee_free: "Sem taxa",
  convert_insufficient: "Saldo insuficiente: você tem {{balance}} e esta conversão precisa de {{debit}}.",
  convert_quote_error: "Não conseguimos calcular a conversão. Tente novamente.",
  convert_pair_unavailable: "Não conseguimos cotar {{from}} para {{to}} agora. Tente em alguns minutos.",
  convert_retry: "Tentar novamente",
  convert_send_tip_title: "Vai enviar este dinheiro para outra pessoa?",
  convert_send_tip_body: "Faça pelo Enviar: convertemos dentro do envio e sai mais barato.",
  convert_send_tip_action: "Ir para Enviar",
  convert_review: "Revisar conversão",
  convert_cancel: "Cancelar",
  convert_close: "Fechar",
  convert_review_title: "Revise e converta",
  convert_review_leaves: "Sai da sua carteira {{currency}}",
  convert_review_lands: "Chega na sua carteira {{currency}}",
  convert_review_irreversible: "A conversão é imediata e não pode ser desfeita.",
  convert_review_edit: "Editar",
  convert_confirm: "Converter {{amount}}",
  convert_review_changed: "O preço mudou enquanto você revisava. Confira os valores antes de converter.",
  convert_processing: "Convertendo seus {{from}} em {{to}}…",
  convert_processing_hint: "Leva só alguns segundos.",
  convert_transit_aria: "Convertendo {{debit}} da sua carteira {{from}} em {{credit}} na sua carteira {{to}}",
  convert_success_title: "Você converteu {{amount}}",
  convert_success_rate: "À taxa {{rate}}",
  convert_success_landed: "Chegou à sua carteira {{currency}}",
  convert_balance_now: "Saldo agora",
  convert_again: "Converter de novo",
  convert_view_movements: "Ver movimentações",
  convert_done: "Pronto",
  convert_error_title: "Não foi possível converter",
  convert_error_generic: "Não conseguimos fazer a conversão. Nada saiu das suas carteiras.",
  convert_error_consumed:
    "A conversão pode ter sido feita mesmo sem a resposta. Confira as movimentações da carteira antes de tentar de novo.",
  convert_error_back: "Voltar",
  convert_read_only:
    "Você pode ver estas carteiras, mas seu usuário não tem permissão para converter. Peça a um administrador da sua organização.",
};
